import _ from 'lodash'
import api from '../../utils/api'
var token = localStorage.getItem('token') || ''
var tokenExpiredAt = new Date(parseInt(localStorage.getItem('tokenExpiredAt') || ''))
if (tokenExpiredAt <= new Date() || tokenExpiredAt.toString() === 'Invalid Date') {
  token = ''
  tokenExpiredAt = new Date()
}

export default {
  state: {
    token,
    tokenExpiredAt,
    user: {}
  },

  mutations: {
    ACCOUNT_RESTORE (state, account) {
      _.assign(state, _.pick(account, ['token', 'tokenExpiredAt']))
    }
  },
  actions: {
    signinByToken ({ commit }) {
      return api('/api/signin/token', 'POST')
    },
    signin ({ commit }, payload) {
      return api('/api/signin', 'POST', payload)
    },
    resetPassword ({ commit }, payload) {
      return api('/api/resetpassword', 'POST', payload)
    },
    getAllUserAccountId ({ commit }, payload) {
      return api('/api/accountids', 'GET', payload)
    },
    insertUser ({ commit }, payload) {
      return api('/api/users', 'POST', payload)
    },
    getUsers ({ commit }, payload) {
      return api('/api/users', 'GET', payload)
    }
  },
  getters: {
    account (state) {
      return {
        token: state.token,
        tokenExpiredAt: state.tokenExpiredAt
      }
    }
  }
}
